<p>vcl-detail-ins-mod works!</p>
